import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-27ca5b35"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "advantage-box common-flex-direction-center"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "common-title wow fadeInUp"
}, "校园外卖的优势", -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "common-des wow fadeInUp",
  "data-wow-delay": "0.2s"
}, "万众创业，互联网生活服务平台最好的时代", -1));

const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = ["data-wow-delay"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "item-title"
};
const _hoisted_8 = {
  key: 0,
  class: "item-des"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "content-item wow zoomIn",
      "data-wow-delay": index * 0.1 + 's',
      key: index
    }, [_createElementVNode("img", {
      class: "item-image",
      src: item.image
    }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1), item.des ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.des), 1)) : _createCommentVNode("", true)], 8, _hoisted_5);
  }), 128))])]);
}